import styled from 'styled-components';


// export const GridContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 1.5rem;
//   padding: 1rem;
//   max-width: 1000px; /* limit width for readability */
//   height : 900px;

//   margin: 0 auto; /* center the container */
//   width: 100%;

//   @media (min-width: 768px) {
//     grid-template-columns: repeat(2, 1fr);
//   }

//   @media (min-width: 1024px) {
//     grid-template-columns: repeat(3, 1fr);
//   }
// `;
export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
`;





// export const Card = styled.div`
//   display: flex;
//   background-color: ${({ theme }) => theme.card || '#18181b'};
//   border: 1px solid ${({ theme }) => theme.text_secondary || '#3f3f46'};
//   border-radius: 12px;
//   overflow: hidden;
//   cursor: pointer;
//   box-shadow: 0 2px 10px rgba(0,0,0,0.5);
//   transition: transform 0.3s ease;
//   gap: 1rem;
//   height: 250px;

//   &:hover {
//     transform: scale(1.02);
//   }

//   @media (max-width: 768px) {
//     flex-direction: column;
//     height: auto;
//   }
// `;






// export const ImageWrapper = styled.div`
//   flex: 1;
//   min-width: 200px;

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }
// `;
export const Card = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.card || '#18181b'};
  border: 1px solid ${({ theme }) => theme.text_secondary || '#3f3f46'};
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  transition: transform 0.3s ease;
  gap: 1rem;
  height: auto;

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;




// export const ImageWrapper = styled.div`
//   flex: 1;
//   min-width: 200px;

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }

//   @media (max-width: 768px) {
//     flex: none;
//     height: 200px; /*  Add a fixed image height */
//     min-width: unset;

//     img {
//       height: 100%;
//     }
//   }
// `;

export const ImageWrapper = styled.div`
  flex: 1;
  width: 100%;
  max-height: 300px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (max-width: 768px) {
    max-height: 200px;
  }
`;




// export const Content = styled.div`
//   flex: 2;
//   padding: 1rem;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   gap: 0.5rem;
// `;
export const Content = styled.div`
  flex: 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
`;




export const Title = styled.h2`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.text_primary || '#fff'};
  font-weight: bold;
`;

export const Description = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.text_secondary || '#a1a1aa'};
`;

export const ReadMore = styled.div`
  color: ${({ theme }) => theme.button || '#3b82f6'};
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: auto;
  font-weight: 600;
`;
